export const PARTICIPANT_KIND = {
  INDIVIDUAL: "INDIVIDUAL",
  LEGAL: "LEGAL",
};

const SERVICE_CODE_CANDIDATES = {
  [PARTICIPANT_KIND.LEGAL]: ["GBDUL", "GBDULBasic"],
  [PARTICIPANT_KIND.INDIVIDUAL]: ["GBDFL"],
};

export function getKind(participant) {
  const raw =
    typeof participant === "string"
      ? participant
      : participant?.participant_type;
  return raw === PARTICIPANT_KIND.LEGAL
    ? PARTICIPANT_KIND.LEGAL
    : PARTICIPANT_KIND.INDIVIDUAL;
}

export function getServiceCodeCandidates(kind) {
  return (
    SERVICE_CODE_CANDIDATES[kind] ||
    SERVICE_CODE_CANDIDATES[PARTICIPANT_KIND.INDIVIDUAL]
  );
}

export function getPrimaryServiceCode(kind) {
  return getServiceCodeCandidates(kind)[0];
}

export function resolveServiceCode(kind, steps = []) {
  const candidates = getServiceCodeCandidates(kind);
  const matched = candidates.find((code) => steps.some((s) => s.code === code));
  return matched ?? candidates[0];
}
